import React from 'react';
import Seat from 'Components/PickSeatManually/InnerSection/Seat';

interface IProps {
  isMobile: boolean;
  selectedSeats: Julius.Website.OrderSeatViewModel[];
  hoveredSeats: Julius.Website.SectionSeatViewModel[];
  innerSection: Julius.Website.InnerSectionViewModel;
  priceCategories?: Julius.Website.PriceCategoryViewModel[];
  onSeatClick: (seat: Julius.Website.SectionSeatViewModel) => void;
  onSeatHoverEnter: (seat: Julius.Website.SectionSeatViewModel) => void;
  onSeatHoverLeave: () => void;
  isFetchingReservations: boolean;
}

class InnerSection extends React.PureComponent<IProps> {
  public static seatRadius: number = 8;

  getMinY = (seats: Julius.Website.SectionSeatViewModel[]) => {
    return seats.reduce((min, seat) => seat.posY < min ? seat.posY : min, seats[0].posY );
  }

  getMinX = (seats: Julius.Website.SectionSeatViewModel[]) => {
    return seats.reduce((min, seat) => seat.posX < min ? seat.posX : min, seats[0].posX );
  }

  getMaxY = (seats: Julius.Website.SectionSeatViewModel[]) => {
    return seats.reduce((max, seat) => seat.posY > max ? seat.posY : max, seats[0].posY );
  }

  getMaxX = (seats: Julius.Website.SectionSeatViewModel[]) => {
    return seats.reduce((max, seat) => seat.posX > max ? seat.posX : max, seats[0].posX );
  }

  getPriceCategory = (seat: Julius.Website.SectionSeatViewModel) => {
    return this.props.priceCategories ? 
      this.props.priceCategories.find(pc => pc.id === seat.priceCategoryID) : undefined;
  }

  isSelected = (seatID: number) => {
    const { selectedSeats } = this.props;
    return selectedSeats.some(s => s.seatID === seatID);
  }

  isHovered = (seatID: number) => {
    const { hoveredSeats } = this.props;
    return hoveredSeats.some(s => s.seatID === seatID);
  }

  getDimensions = () => {
    const { isMobile, innerSection: { seats } } = this.props;

    const minX = this.getMinX(seats);
    const minY = this.getMinY(seats);
    const maxX = this.getMaxX(seats);
    const maxY = this.getMaxY(seats);
    const shiftY = minY - InnerSection.seatRadius;
    const shiftX = minX - InnerSection.seatRadius;
    const svgWidth = maxX - shiftX + InnerSection.seatRadius;
    const svgHeight = maxY - shiftY + InnerSection.seatRadius;
    const containerHeight = '100%';

    const containerWidth = 
      svgWidth > 650 ? '100%' :
      svgWidth > 500 && isMobile ? '100%' :
      svgWidth > 500 && !isMobile? '80%' :
      svgWidth < 120 && isMobile ? '12%' :
      svgWidth < 70 && !isMobile ? '7%' : 
      `${ svgWidth / 10 }%`;

    return { 
      svgWidth, 
      svgHeight, 
      containerWidth,
      containerHeight, 
      shiftX, 
      shiftY,
    };
  }
  
  render() {

    if (!this.props.innerSection) {
      return null;
    }

    const { innerSection: { seats }, onSeatClick, onSeatHoverEnter, onSeatHoverLeave, isFetchingReservations } = this.props;
    const dim = this.getDimensions();

    return (
      <svg 
        width={ dim.containerWidth }
        height={ dim.containerHeight }
        viewBox={ `0, 0, ${ dim.svgWidth }, ${ dim.svgHeight }` }
        style={ { 
          padding: `${ InnerSection.seatRadius / 2 }px`, 
          margin: '0 auto' ,
        } }
      >
        { seats.map((s, i) => (
          <Seat 
            key={ `seat-${ i }` }
            seat={ s }
            priceCategory={ this.getPriceCategory(s) }
            posX={ s.posX - dim.shiftX } 
            posY={ s.posY - dim.shiftY } 
            radius={ InnerSection.seatRadius }
            onClick={ onSeatClick }
            onMouseEnter={ onSeatHoverEnter }
            onMouseLeave={ onSeatHoverLeave }
            isSelected={ this.isSelected(s.seatID) }
            isHovered={ this.isHovered(s.seatID) }
            isAvailable={ s.status === 1 }
          />))
        }
      </svg>
    )
  }
}

export default InnerSection;


// WEBPACK FOOTER //
// ./src/components/PickSeatManually/InnerSection/InnerSection.tsx